/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const comparator = (a, b) => {
  const splittedQtrA = a?.split('Q') || [0, 0];
  const splittedQtrB = b?.split('Q') || [0, 0];
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
export const cmsTableHead = [
  {
    headerName: 'Actions',
    field: 'index',
    sortable: false,
    filter: false,
    maxWidth: Styles.Width_100,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    cellRenderer: 'DeleteActionRender',
    resizable: false,
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    cellRenderer: 'StartQtrTextbox',
    sort: 'asc',
    required: true,
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    minWidth: 182,
    custClass: 'tbill-rate-editable-input',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator,
  },

  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: 150,
    cellRenderer: 'EndQtrTextbox',
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'endsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator,
  },
  {
    headerName: 'Spec Thera Code',
    field: 'specTheraCode',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    required: true,
    minWidth: 208,
    cellRenderer: 'SpecTheraTextbox',
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Generic Code Number',
    field: 'genCodeNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    required: true,
    minWidth: 240,
    resizable: false,
    sortingOrder: ['asc', 'desc'],
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
    },
    minWidth: Styles.Width_280,
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const postSortRows = (params) => {
  const rowNodes = params.nodes;
  let nextInsertPos = 0;
  for (let i = 0; i < rowNodes.length; i += 1) {
    if (
      !rowNodes[i].data.lastUpdateDt ||
      rowNodes[i].data.lastUpdateDt === ''
    ) {
      rowNodes.splice(nextInsertPos, 0, rowNodes.splice(i, 1)[0]);
      nextInsertPos += 1;
    }
  }
};
